import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/eventConstants';
import dayjs from 'dayjs';

const initialState = {
  date: dayjs(new Date()).toISOString(),
  event: null,
  events: [],
  loading: true,
};

const eventsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_EVENTS:
      return {
        ...initialState,
      };
    case types.GET_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        events: payload.map((event) => ({
          id: event.id,
          title: event.title,
          start: new Date(event.startDate),
          end: new Date(event.endDate),
        })),
      };
    case types.SELECT_EVENT:
      return {
        ...state,
        event: payload,
      };
    case types.CLEAR_SELECTED_EVENT:
      return {
        ...state,
        event: null,
      };
    case types.GET_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SET_EVENTS_DATE:
      return {
        ...state,
        date: dayjs(new Date(payload)).toISOString(),
      };
    default:
      return state;
  }
};

export default eventsReducer;
